
const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Load Weight Vol from Master',
  description: 'Checks if this is a known material - if available  in master then it will take weight and volume to show it in the documents section',
  sortOrder: 1,
  name: 'loadWtVolFromMaster',
  documentKey: 'load_wt_vol_from_master',
  values: {
    load_wt_vol_from_master: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Load Weight and Volume from Master',
      documentKey: 'load_wt_vol_from_master',
    },
  },
};
